<template>
  <div>
    <NavigationBar
      titel="Neue Lehrgangsgruppe anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="createItem"
      >
        <course-group-editor
          v-model="courseGroup"
          mode="new"
        ></course-group-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { CREATE_COURSE_GROUP } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import CourseGroupEditor from "@/components/member-management/courses/CourseGroupEditor.vue";

export default {
  name: "member-management-config-course-group-new",
  components: {
    NavigationBar,
    CourseGroupEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      courseGroup: {
        title: null,
        color: "#F44336FF",
        icon: null,
      },
    };
  },

  methods: {
    createItem() {
      this.$refs.form.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MEMBER_MANAGEMENT}${CREATE_COURSE_GROUP}`, {
          organizationId: this.$route.params.organizationId,

          title: this.courseGroup.title,
          sortKey: this.courseGroup.sortKey,
          color: this.courseGroup.color,
          icon: this.courseGroup.icon,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>

<style></style>
